import { createAction, props } from '@ngrx/store';
import {
  ICart,
  NewOrderDTO,
  IAddress,
  ICoupon,
  IOrder
} from '@care-portals/api-interfaces';

export const loadCart = createAction(
  '[Checkout] Load Cart',
  props<{ cartId: string }>()
);

export const loadCartSuccess = createAction(
  '[Checkout] Load Cart Success',
  props<{ cart: ICart }>()
);

export const loadCartFailure = createAction(
  '[Checkout] Load Cart Failure',
  props<{ error: Error }>()
);

export const linkCartToCustomer = createAction(
  '[Checkout] Link Cart To Customer',
  props<{ cartId: string }>()
);

export const loadAddresses = createAction('[Checkout] Load Customer Addresses');

export const loadAddressesSuccess = createAction(
  '[Checkout] Load Customer Addresses Success',
  props<{ addresses: IAddress[] }>()
);

export const loadAddressesFailure = createAction(
  '[Checkout] Load Customer Addresses Failure',
  props<{ error: Error }>()
);

export const addAddress = createAction(
  '[Checkout] Save Customer Addresses',
  props<{ address: IAddress }>()
);

export const addAddressSuccess = createAction(
  '[Checkout] Save Customer Addresses Success',
  props<{ addresses: IAddress[] }>()
);

export const addAddressFailure = createAction(
  '[Checkout] Save Customer Addresses Failure',
  props<{ error: Error }>()
);

export const createOrder = createAction(
  '[Checkout] Create Order',
  props<{ newOrder: NewOrderDTO }>()
);

export const createOrderSuccess = createAction(
  '[Checkout] Create Order Success',
  props<{ orderId: number; order: IOrder }>()
);

export const createOrderFailure = createAction(
  '[Checkout] Create Order Failure',
  props<{ error: Error }>()
);

// export const setShippingAddress = createAction(
//     '[Checkout] Set Checkout Shipping IAddress',
//     props<{ cartId: string, address: IAddress }>()
// )

// export const setShippingAddressSuccess = createAction(
//     '[Checkout] Set Checkout Shipping IAddress Success',
//     props<{ res: any }>()
// )

// export const setShippingAddressFailure = createAction(
//     '[Checkout] Set Checkout Shipping IAddress Failure',
//     props<{ error: Error }>()
// )

export const applyCoupon = createAction(
  '[Checkout] Apply Coupon',
  props<{ code: string; cartId?: string }>()
);

export const applyCouponSuccess = createAction(
  '[Checkout] Apply Coupon Success',
  props<{ coupon: ICoupon }>()
);

export const applyCouponFailure = createAction(
  '[Checkout] Apply Coupon Failure',
  props<{ error: Error }>()
);

export const setOrderItems = createAction('[Checkout] Set Order Items');

export const setOrderItemsSuccess = createAction(
  '[Checkout] Set Order Items Success',
  props<{ orderItems: Array<any> }>()
);

export const nullAction = createAction('[Checkout] Null');
